module.exports = __webpack_public_path__ + "static/media/1007327.2dac1fbd.jpg";